import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { CommunityDetailDataObject } from 'models/service';

export const getCommunity = async ({ id, invitationToken }: { id: string; invitationToken?: string }) =>
  apiClient.get<CommunityDetailDataObject, ApiClientResponse<CommunityDetailDataObject>>(routes.community.get(id), {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- We missing correct application model in camelCase, we need to fix it
    params: { invitation_token: invitationToken },
  });
